
import {
    SET_ISKN_DATE,
    SET_OPSUB_ITEM
} from '../../sagas/analyzeDefunctPar';

import {
    GET_PROJECT_ACTION_TYPE
} from '../../sagas/project';

const initialState = {
    isknDate: null,
    opsubItem: null
};

export function getIsknDate(state) {
    return state.isknDate;
}

export function getOpsubItem(state) {
    return state.opsubItem;
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case GET_PROJECT_ACTION_TYPE.SUCCESS:
            return {
                ...initialState
            };

        case SET_ISKN_DATE:
            return {
                ...state,
                isknDate: action.isknDate
            };

        case SET_OPSUB_ITEM:
            return {
                ...state,
                opsubItem: action.opsubItem
            };

        default:
            return state;
    }
}
